export default __webpack_public_path__ + "static/media/3031 knife block B top.2c76a0f5.png";